export default __webpack_public_path__ + "media/images/action2-a3a2532540118370c859f8e4b0270d65.png";